/// <amd-module name="TFS/Admin/Views/OrganizationPolicies/Contracts/DataModels" />

export interface IPolicy extends PolicyData {
    policy: Policy;
}

export interface Policy {
    effectiveValue: any;
    enforce: boolean;
    isValueUndefined: boolean;
    name: string;
    parentPolicy: Policy;
    value: any;
}
export interface PolicyInfo {
    description: string;
    moreInfoLink: string;
    name: string;
}

export interface OrganizationPoliciesComponentState {
    showErrorMessage: boolean;
    updateInProgress: boolean;
    data: PoliciesData;
}

export interface PolicyUpdateConfig {
    policy: IPolicy;
    section: PolicyType;
    key: string;
    value: boolean;
    enforce: boolean;
    invertedPolicies: string[];
}

export interface PoliciesData {
    invertedPolicies: string[];
    isOrganizationActivated: boolean;
    permissionBits: number;
    policies: PolicyCollection;
    isMicrosoftTenant: boolean;
    isGuestUser: boolean;
    hostId: string;
    requestAccessUrl: string;
}

export interface PolicyCollection {
    applicationConnection: PolicyData[];
    directory: PolicyData[];
    security: PolicyData[];
    user: PolicyData[];
    workItemLinking: PolicyData[];
}

export interface PolicyData {
    applicableServiceHost: number;
    description: string;
    learnMoreLink: string;
    policy: any;
}

export type PolicyType = keyof PolicyCollection;

export module PermissionConstants {
    export const MODIFY = 1;
    export const MODIFY_PROPERTIES = 2;
    export const DELETE = 4;
    export const MODIFY_COLLECTION = 16;
    export const DELETE_COLLECTION = 32;
}

export enum PolicyValue {
    On = 1,
    Off
}
export module HostTypeConstants {
    export const NONE = 0;
    export const COLLECTION = 1;
    export const ORGANIZATION = 2;
}

export module ComponentConstants {
    export const NULL_AS_STRING = "null";
    export const TRUE_AS_STRING = "true";
}

export interface DialogMessage {
    title: string;
    confirmationMessage: string;
    warningMessage?: string;
    learnMoreLink?: string;
}

export interface RequestAccessMessage {
    requestAccessTitle: string;
    requestAccessMessage: string;
    requestAccessLearnMoreLink: string;
}

export module PolicyNames {
    export const DisallowOAuthAuthentication = "Policy.DisallowOAuthAuthentication";
    export const DisallowAadGuestUserAccess = "Policy.DisallowAadGuestUserAccess";
    export const DisallowSecureShell = "Policy.DisallowSecureShell";
    export const EnforceAadAuthorization = "Policy.EnforceAadAuthorization";
    export const AuthenticationCredentialValidFrom = "Policy.AuthenticationCredentialValidFrom";
    export const IsInternal = "Policy.IsInternal";
    export const AllowAnonymousAccess = "Policy.AllowAnonymousAccess";
    export const AllowOrgAccess = "Policy.AllowOrgAccess";
    export const EnforceAADConditionalAccess = "Policy.EnforceAADConditionalAccess";
    export const IsReadOnly = "Policy.IsReadOnly";
    export const AllowGitHubInvitations = "Policy.AllowGitHubInvitationsAccessToken";
    export const AllowRequestAccess = "Policy.AllowRequestAccessToken";
    export const Namespace = "Policy";
}

export module SourceConstants {
    export const VALUE_PATH = "/Value";
    export const ENFORCE_PATH = "/Enforce";
    export const NAME_PATH = "/Name";
    export const IS_ACTIVATED_PATH = "/IsActivated";
    export const TENANT_ID_PATH = "/TenantId";
    export const REQUEST_ACCESS_URL_PATH = "/SystemProperty.RequestAccessUrl";
}
